import React from 'react';
import type { ShellSlotName } from '../../contexts/LayoutContext';
import { useShellLayout } from '../../hooks/useShellLayout';

interface ShellSlotProps extends React.HTMLAttributes<HTMLElement> {
  slot: ShellSlotName;
  as?: React.ElementType;
  children?: React.ReactNode;
}

const ShellSlot: React.FC<ShellSlotProps> = ({ slot, as: Component = 'div', className, style, children, ...rest }) => {
  const { slots } = useShellLayout();
  const slotDefinition = slots[slot];
  const mergedClassName = [slotDefinition.className, className].filter(Boolean).join(' ');

  return React.createElement(
    Component as React.ElementType,
    {
      ...(rest as Record<string, unknown>),
      className: mergedClassName,
      style: { ...slotDefinition.style, ...style },
    },
    children,
  );
};

export default ShellSlot;
